import React from 'react';
import { Breadcrumb } from 'react-bootstrap';

const Breadcrumbs = ({ items }) => {
  return (
    <Breadcrumb className="mb-3">
      {items.map((item, idx) => (
        <Breadcrumb.Item
          key={idx}
          active={idx === items.length - 1}
          href={item.href}
        >
          {item.label}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
